{
  "title": "Settings",
  "description": "Manage your account, security, and preferences.",
  "sectionsHeading": "Settings",
  "appearanceHeading": "Appearance",
  "appearanceDescription": "Choose how the app looks. Your theme is saved on this device.",
  "rows": {
    "profile": {
      "title": "Profile",
      "description": "Update your name, email, and personal details."
    },
    "security": {
      "title": "Security",
      "description": "Manage your password, two-factor authentication, and sessions."
    },
    "notifications": {
      "title": "Notifications",
      "description": "Choose how and when we reach you."
    },
    "privacy": {
      "title": "Privacy",
      "description": "Manage consent, data export, and account deletion."
    },
    "billing": {
      "title": "Billing",
      "description": "View your plan, invoices, and payment details."
    }
  }
}
